import { PREDEFINED_TAGS } from '../pages/DesignSystem/types/tags.types';

export interface PriceItem {
  amount: number | null;
  description: string;
  currency: string;  // Pour spécifier la devise (EUR, LKR, etc.)
}

export interface Event {
  id: string;
  organizerId: string;
  organizerContact?: string;
  organizer?: string;
  organizerImage?: string;
  organizerSubtitle?: string;
  title: string;
  description?: string;
  datetime?: Date;
  endTime?: string;
  endDateTime?: string;  // Ajout du nouveau champ
  timezone: string; // Fuseau horaire IANA de l'événement (ex: 'Asia/Colombo', 'Europe/Paris')
  location?: string;
  locationName?: string;
  latitude?: number;
  longitude?: number;
  geohash?: string;
  tags: string[];
  image?: string;
  prices?: PriceItem[];
  ticketingUrl?: string; 
  views?: number;
  status: 'active' | 'draft' | 'cancelled';
  cancelledAt?: Date;
  cancellationReason?: string;
  attendees?: number;
  createdAt?: Date;
  updatedAt?: Date;
  seriesId?: string;
  isException?: boolean;
  
  // Propriétés spécifiques aux événements récurrents
  weekDays?: string[];
  seriesFrequency?: 'daily' | 'weekly';
  seriesEndType?: 'date' | 'occurrences';
  time?: string;
  seriesEndDate?: Date;
  seriesOccurrences?: number;

  // Import intelligent (PRD-import-intelligent-events.md)
  importConfidence?: number;   // 0-1, AI confidence score (null for manual events)
  importSource?: string;       // 'photo' | 'pdf' | 'excel' | 'csv' | 'instagram_link' | 'instagram_screenshot'
}

export type DateFilterValue = 'today' | 'tomorrow' | 'weekend' | 'custom' | '';

export interface DateFilter {
  id: string;
  label: string;
  value: DateFilterValue;
}

export interface TimeFilter {
  id: string;
  label: string;
  icon: string;
  value: 'morning' | 'afternoon' | 'evening' | 'all';
}

export const DATE_FILTERS: DateFilter[] = [
  { id: 'today', label: 'Today', value: 'today' },
  { id: 'tomorrow', label: 'Tomorrow', value: 'tomorrow' },
  { id: 'weekend', label: 'This Weekend', value: 'weekend' },
  { id: 'custom', label: 'Choose Date', value: 'custom' }
];

export const TIME_FILTERS: TimeFilter[] = [
  { id: 'morning', label: 'Morning', icon: '🌅', value: 'morning' },
  { id: 'afternoon', label: 'Afternoon', icon: '☀️', value: 'afternoon' },
  { id: 'evening', label: 'Evening', icon: '🌙', value: 'evening' }
];

export { PREDEFINED_TAGS as EVENT_TAGS };
